import { createEnum } from '../../../../utils/createEnum'

export const VisitMethods = createEnum('video', 'call', 'inperson')
export type VisitMethods = (typeof VisitMethods)['__type']

export const VisitMethodOptions = createEnum(['Video', 'Phone', 'In-person'])
export type VisitMethodOptions = (typeof VisitMethodOptions)['__type']

export const NON_IN_PERSON_METHOD_OPTIONS = [VisitMethodOptions.VIDEO, VisitMethodOptions.PHONE]
export const VIDEO_ONLY_METHOD_OPTIONS = [VisitMethodOptions.VIDEO]

export const getVisitMethodFromMethodOption = (option: VisitMethodOptions): VisitMethods => {
  switch (option) {
    case VisitMethodOptions.VIDEO:
      return VisitMethods.VIDEO
    case VisitMethodOptions.PHONE:
      return VisitMethods.CALL
    case VisitMethodOptions.IN_PERSON:
      return VisitMethods.INPERSON
    default:
      // makes sure that if new option is added but that case is not added here, it will be caught by the compiler
      throw new Error(`Invalid visit method option: ${option satisfies never}`)
  }
}

export const getVisitMethodOptionFromVisitMethod = (method: VisitMethods): VisitMethodOptions => {
  switch (method) {
    case VisitMethods.VIDEO:
      return VisitMethodOptions.VIDEO
    case VisitMethods.CALL:
      return VisitMethodOptions.PHONE
    case VisitMethods.INPERSON:
      return VisitMethodOptions.IN_PERSON
    default:
      // makes sure that if new option is added but that case is not added here, it will be caught by the compiler
      console.error(`Invalid visit method: ${method satisfies never}`)
      return VisitMethodOptions.VIDEO
  }
}
